export const validate = () => {
	const errors = {};

	return errors;
};
